import * as React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export var ProductTableHeaderBanner = function ProductTableHeaderBanner(_ref) {
  var bannerInfo = _ref.bannerInfo,
      _ref$badge = _ref.badge,
      badge = _ref$badge === void 0 ? false : _ref$badge,
      _onClick = _ref.onClick;
  return _jsx("div", {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFD555',
      padding: 'sm',
      color: 'primary',
      lineHeight: 'base',
      fontSize: 'xs',
      fontWeight: 'bold'
    },
    children: _jsxs("span", {
      sx: {
        marginTop: badge ? '10px' : '0'
      },
      children: [bannerInfo.text, "\xA0", _jsx("span", {
        sx: {
          variant: 'styles.a',
          fontWeight: 'base',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _onClick();
        },
        children: bannerInfo.linkText
      })]
    })
  });
};
//# sourceMappingURL=header-banner.js.map